// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".student_administrator_screen-layout .container-buttons-filter {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  justify-content: flex-end; }\n", ""]);
// Exports
module.exports = exports;
